import type { PipingSystem } from '../../types/pcfExport.types';

export const E2E_NO_MATCH_SYSTEM_NAME = 'PIPEEX-E2E-NO-SNAPSHOT-MATCH 1';

export type E2eMockSystemsMode = 'catalog' | 'no-match';

export function getE2eMockSystemsMode(): E2eMockSystemsMode | null {
  if (process.env.REACT_APP_PIPEEX_E2E_BYPASS !== '1' || typeof window === 'undefined') {
    return null;
  }

  const requestedMode = new URLSearchParams(window.location.search).get('e2eMockSystems');
  if (requestedMode === '1') {
    return 'catalog';
  }
  return requestedMode === 'no-match' ? 'no-match' : null;
}

export function buildE2eMockPipingSystems(mode: E2eMockSystemsMode = 'catalog'): PipingSystem[] {
  if (mode === 'no-match') {
    return [{
      systemName: E2E_NO_MATCH_SYSTEM_NAME,
      elementCount: 1,
      status: 'Ready',
      warningCount: 0,
      errorCount: 0,
      elementIds: ['999999999'],
      sessionExportCount: 0,
    }];
  }

  const counts = [
    118, 42, 28, 55, 62, 85, 60, 53, 26, 24, 32, 34, 44, 43, 6, 91, 38, 47, 58, 29, 73, 19, 66, 41, 12, 37, 50, 22, 8,
    95,
  ];
  return counts.map((elementCount, index) => {
    const n = index + 1;
    let status: PipingSystem['status'] = 'Errors';
    let errorCount = (n % 4) + 1;
    let warningCount = 0;
    if (n % 15 === 0) {
      status = 'Warnings';
      errorCount = 0;
      warningCount = (n % 5) + 2;
    } else if (n % 7 === 0) {
      status = 'Ready';
      errorCount = 0;
    } else if (n === 3) {
      status = 'NotValidated';
      errorCount = 0;
    }

    return {
      systemName: `BL-DUMMY-${String(n).padStart(3, '0')} 1`,
      elementCount,
      status,
      warningCount,
      errorCount,
      elementIds: Array.from({ length: Math.min(elementCount, 3) }, (_, i) => `${100000 + n * 10 + i}`),
      sessionExportCount: n % 9 === 0 ? 2 : 0,
      PiP_PPG_SPEC: 'DUMMY',
      PiX_03_Material_ENG: '<By Category>',
      PiX_02_Standard_ENG: 'EN 13480',
      PiX_PPG_END1_PressureRating: 'PN16',
      PiX_GN_2_InsulationSpec: n % 2 === 0 ? 'INS-HOT-50' : '',
    };
  });
}

export function isE2eMockSystemsRequested(): boolean {
  return getE2eMockSystemsMode() !== null;
}
